import messengerApiService from '@widgets/messenger/services/messengerApiService'
import sentryMonitoringService from '@widgets/shared/services/monitoring/sentryMonitoringService'
import loggerService from '@widgets/shared/services/loggerService'
import { useChatStore } from '@widgets/messenger/stores/useChatStore'
import { useWidgetChatEventHandlers } from '@widgets/messenger/compositions/useWidgetChatEventHandlers'
import type { MessengerWebSocketEventMap, MessengerWebSocketEventTypes } from '@widgets/messenger/types/api/websocket'
import type { ServerEventsUnionFromMap } from '@/services/transport/types'

export const useWidgetChatEventHistory = () => {
  const chatStore = useChatStore()
  const { handleChatEvent } = useWidgetChatEventHandlers()
  const systemEvents: Set<MessengerWebSocketEventTypes> = new Set(['chatConversationEnded', 'liveChatAgentChanged'])

  const handleSystemEvents = (history: ServerEventsUnionFromMap<MessengerWebSocketEventMap>[] = []) => {
    history.forEach((event) => {
      if (systemEvents.has(event.type)) {
        handleChatEvent(event)
      }
    })
  }

  const fetchHistory = async () => {
    try {
      const history = await messengerApiService.getEventHistory(chatStore.chatToken.value)
      handleSystemEvents(history)
    } catch (e) {
      sentryMonitoringService.logError(e as Error)
      loggerService.logError((e as Error).message)
    }
  }

  return {
    fetchHistory,
  }
}
